import React from 'react';
import { PropTypes } from 'prop-types';
import { Breadcrumbs, HelmetWrapper } from 'sarsaparilla';

const propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  additionalInformation: PropTypes.string
};

export default class TertiaryContent extends React.Component {
  renderBreadcrumb() {
    const path = [
      { url: '/', title: 'Home' },
      { url: `/permits/${this.props.id}`, title: this.props.name },
      { title: 'Additional Information' }
    ];

    return (
      <Breadcrumbs path={path} />
    );
  }

  /* eslint-disable react/no-danger */
  renderTertiaryDesc() {
    return (
      <div className="tertiary-content">
        <h1>{this.props.name}</h1>
        <div id="division-permit-desc" className="permit-division-description" dangerouslySetInnerHTML={{ __html: this.props.additionalInformation }} />
      </div>
    );
  }
  /* eslint-enable react/no-danger */

  render() {
    return (
      <div className="permit-content-outer-wrap">
        <HelmetWrapper title={`${this.props.name} Additional Information`} />
        <section className="permit-content-main division-details-container">
          {this.renderBreadcrumb()}
          {this.renderTertiaryDesc()}
        </section>
      </div>
    );
  }
}

TertiaryContent.propTypes = propTypes;
